let dummyData = [
    {
        house_no: '1',
        img:"https://th.bing.com/th/id/OIP.5cPRakAop6ITYq784MvCtQHaE7?pid=ImgDet&rs=1",         
        isOccupied: true,
        resident: 'John Doe',
        phone: '123456789',
        due_date: '12/12/2021',
        amount: '10000',
        paymentStatus: 'pending',
        address: '123, ABC Street, XYZ City',
        email: 'abc@abc.com',
        properties: '2',
        activeProperties: '1',
        city: 'Karachi',
        paymentDate: '12/12/2021'
    },
    {
        house_no: '2',
        img:"https://th.bing.com/th/id/OIP.K2XHZApjhJtr7KaMROuZiQHaE7?pid=ImgDet&rs=1",
        resident: 'Jane Smith',
        isOccupied: true,
        phone: '987654321',
        due_date: '15/12/2021',
        address: '456, DEF Avenue, XYZ City',
        email: 'def@xyz.com',
        properties: '3',
        activeProperties: '2',
        amount: '10000',
        paymentStatus: 'paid',
        city: 'Lahore',
        paymentDate: '11/12/2021'
    },
    {
        house_no: '3',
        // resident: 'Mike Johnson',
        img:"https://th.bing.com/th/id/OIP.0j7i09GZ4LvaYQZVZdgDqgHaE7?pid=ImgDet&rs=1",
        isOccupied: false,
        // phone: '567890123',
        address: '789, GHI Road, XYZ City',
        email: 'ghi@example.com',
        properties: '1',
        activeProperties: '1',
        due_date: '20/12/2021',
        // amount: '200',
        paymentStatus: 'pending',
        city: 'Islamabad',
        paymentDate: '19/12/2021'
    },
    {
        house_no: '4',
        resident: 'Emily Brown',
        img:"https://th.bing.com/th/id/R.019d17457a46330d19eab4acfb0d94f9?rik=m%2bnDYOKcnyT6BQ&riu=http%3a%2f%2fcampus.murraystate.edu%2facademic%2ffaculty%2fBAtieh%2fHouse17.jpg&ehk=pGtHIgJgUEBMiYaxKn9JZaHEz%2bVdNI%2bKKdxVzXJOIcY%3d&risl=&pid=ImgRaw&r=0",
        isOccupied: true,
        phone: '432109876',
        email: 'jkl@sample.com',
        properties: '2',
        activeProperties: '1',
        due_date: '18/12/2021',
        amount: '12000',
        paymentStatus: 'paid',
        city: 'Rawalpindi',
        address: '567, JKL Lane, XYZ City',
        paymentDate: '10/12/2021'
    },
    {
        house_no: '6',
        // resident: 'Sarah Johnson',
        img:"https://th.bing.com/th/id/OIP.5khdDrdDnaFFxCVb4y-cgAHaEo?pid=ImgDet&rs=1",
        isOccupied: false,
        // phone: '345678901',
        email: 'pqr@example.com',
        properties: '1',
        activeProperties: '0',
        due_date: '22/12/2021',
        // amount: '80',
        address: '789, PQR Lane, XYZ City',
        paymentStatus: 'pending',
        city: 'Karachi',
        paymentDate: '21/12/2021'
    },
    {
        house_no: '5',
        resident: 'William Davis',
        img:"https://th.bing.com/th/id/OIP.nynfKuZ7xUA58B-n6jQS0wHaE6?pid=ImgDet&rs=1",
        isOccupied: true,
        phone: '901234567',
        email: 'mno@demo.com',
        properties: '3',
        activeProperties: '2',
        due_date: '25/12/2021',
        amount: '7000',
        address: '890, MNO Street, XYZ City',
        paymentStatus: 'pending',
        city: 'Faisalabad',
        paymentDate: '20/12/2021'
    },
];

export default dummyData;
